//EDI MODAL
// export const usDocType = [
//   "DOC_ISF",
//   "DOC_ENTRY_7501",
//   "DOC_ENTRY_7501_NON_COMBINED",
//   "DOC_ENTRY_3461",
//   "DOC_CR_BOL_QUERY_REQUEST",
// ];
export const usDocType = [
  { name: "DOC ISF", value: "DOC_ISF" },
  { name: "DOC ENTRY 7501", value: "DOC_ENTRY_7501" },
  { name: "DOC ENTRY 7501 NON COMBINED", value: "DOC_ENTRY_7501_NON_COMBINED" },
  { name: "DOC ENTRY 3461", value: "DOC_ENTRY_3461" },
  { name: "DOC CR BOL QUERY ", value: "DOC_CR_BOL_QUERY_REQUEST" },
];
// export const canadaDocType = [
//   "DOC_AB",
//   "DOC_AD",
//   "DOC_C",
//   "DOC_D",
//   "DOC_F",
//   "DOC_H",
//   "DOC_M",
//   "DOC_V",
// ];
export const canadaDocType = [
  { name: "DOC AB", value: "DOC_AB" },
  { name: "DOC AD", value: "DOC_AD" },
  { name: "DOC C", value: "DOC_C" },
  { name: "DOC D", value: "DOC_D" },
  { name: "DOC F", value: "DOC_F" },
  { name: "DOC H", value: "DOC_H" },
  { name: "DOC M", value: "DOC_M" },
  { name: "DOC V", value: "DOC_V" },
];
export const ukDocType = [{ name: "DOC C88", value: "DOC_C88" }];
// export const ukDocType = ["DOC_C88"];
export const USactions = ["ADD", "UPDATE"];
export const US7501actions = ["ADD", "REPLACE"];
export const CAactions = [
  "ADD_CBSA",
  "CHANGE_CBSA",
  "CANCEL_CBSA",
  "AMEND_CBSA",
];
export const UKactions = ["NEW", "REPLACE", "CANCEL"];

export const DOC_ENTRY_7501 = ["ADD", "REPLACE"];
export const DOC_ENTRY_7501_NON_COMBINED = ["REPLACE", "RETRACT"];
export const DOC_ENTRY_3461 = ["UPDATE", "RETRACT"];
export const DOC_ISF = ["ADD", "REPLACE", "RETRACT"];
export const DOC_CR_BOL_QUERY_REQUEST = ["ADD"];
export const EDI_FORMAT = ["EDI_CUSDEC", "EDI_SWI_IID"];
